import { useTranslation } from "react-i18next";
import { ListFilter } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../../../../components/shadcn/popover";
import { FilterRuleProps } from "../../../../main/component/filter/AdvancedFilter";
import FieldPicker from "./FieldPicker";

type FieldOption = {
  label: string;
  value: string;
  data: any;
};

type FilterButtonProps = {
  fields: FieldOption[];
  onAdd: (rule: FilterRuleProps) => void;
};

/**
 * Compact "Add filter" pill button.
 * Dashed border, filter icon. Clicking opens field picker popover.
 * Uses Radix UI Popover via shadcn wrapper.
 */
const FilterButton = ({ fields, onAdd }: FilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 rounded-lg border border-dashed border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-colors cursor-pointer outline-none">
          <ListFilter className="w-3.5 h-3.5" />
          <span>{t("Add filter")}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={8}
        className="w-auto p-0 rounded-xl bg-white z-[9999]"
      >
        <FieldPicker
          fields={fields}
          onSelect={(rule) => {
            onAdd(rule);
          }}
          onClose={() => {}}
        />
      </PopoverContent>
    </Popover>
  );
};

export default FilterButton;
